<div class="d-flex align-items-center">
  <span
    [attr.data-automation-id]="dataAutomationId || 'record-source-info'"
    [caLocalizationScope]="L10N"
    class="text-muted body-50"
  >
    {{ 'recordSource' | caLocalize }}: {{ source | caLocalize }}
  </span>

  <i
    class="f-i f-i-sm f-i-help text-muted cursor-pointer text-primary-600-hover"
    (click)="onOpenExplanationModal()"
  ></i>
</div>
